import React, { useState } from 'react';
import { ASSETS } from '../data/siteData';

interface BrandLogoProps {
  className?: string;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ className = '', showText = true, size = 'md' }) => {
  const [imageError, setImageError] = useState(false);

  const sizeClasses = {
    sm: 'h-8 min-w-[100px]',
    md: 'h-10 min-w-[130px]',
    lg: 'h-14 min-w-[180px]',
  };

  return (
    <div className={`flex items-center gap-2.5 select-none ${className}`} style={{ minWidth: '80px' }}>
      {!imageError ? (
        <img
          src={ASSETS.logo}
          alt="AMGOC US LLC Logo"
          className={`${sizeClasses[size]} object-contain`} width={size === "lg" ? 180 : size === "md" ? 130 : 100} height={size === "lg" ? 56 : size === "md" ? 40 : 32}
          onError={() => setImageError(true)}
        />
      ) : (
        <div className="flex items-center gap-2">
          {/* Geometric 3-Pyramid SVG Fallback from Brand Book */}
          <svg width="36" height="30" viewBox="0 0 36 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 2L32 26H4L18 2Z" fill="url(#blue_grad_1)" />
            <path d="M18 8L26 24H10L18 8Z" fill="#3B82F6" />
            <path d="M18 14L22 22H14L18 14Z" fill="#031121" />
            <defs>
              <linearGradient id="blue_grad_1" x1="18" y1="2" x2="18" y2="26" gradientUnits="userSpaceOnUse">
                <stop stopColor="#60A5FA" />
                <stop offset="1" stopColor="#1E40AF" />
              </linearGradient>
            </defs>
          </svg>
          {showText && (
            <div className="flex flex-col">
              <span className="font-extrabold tracking-widest text-slate-900 dark:text-white text-lg leading-tight">
                AMGOC <span className="text-royal-blue">US</span>
              </span>
              <span className="text-[10px] tracking-widest text-slate-mist uppercase font-semibold">
                LLC
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
